import React from "react";
import { Blok } from "../types";
import FeaturedSlots from "../components/FeaturedSlots";
import PromoSlots from "../components/PromoSlots";
import Banner from "../components/PromosBanner";
import LegalContent from "../components/PromosLegalContent";
import SeoContent from "../components/PromoSeoContent";
import PromosBodyContent from "../components/PromosBodyContent";
import HandicappingSection from "../components/HandicappingSection";
import EligibleRaces from "../components/EligibleRaces";

let COMPONENTS_DICTIONARY = Object.create(null);

COMPONENTS_DICTIONARY = {
  handicapping: HandicappingSection,
  banner: Banner,
  top_promos: FeaturedSlots,
  all_promos: PromoSlots,
  legal_content: LegalContent,
  seo_content: SeoContent,
  content_section: PromosBodyContent,
  eligibleRaces: EligibleRaces
};

/* eslint-disable no-underscore-dangle */
export default (blok: Blok) => {
  if (typeof COMPONENTS_DICTIONARY[blok.component] !== "undefined") {
    return React.createElement(COMPONENTS_DICTIONARY[blok.component], {
      key: blok._uid,
      content: blok
    });
  }

  return null;
};
